import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import arrow from './../../assets/img/custom/arrow.png'
import BookingModal from '../../page/bookingModal';

const Team = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <>
            <section  >
                <div className="container">
                    {/* <Heading heading="Expert Team" para="This is our expert team members of AndShop" /> */}
                    <div className="row">
                        {props.TeamData.map((data, index) => (
                            <div className="col-lg-4" key={index} style={{marginTop: '8%'}}>
                                <div className="team_slider">

                                    <div className="team-single">
                                    <img src={process.env.REACT_APP_IMG_URL + data.image} className="doctorImg" />
                                        <div className="team-bottom">
                                            <p>{data.name[i18n.language]}</p>
                                            <p className="text-black font-weight-bold">{data.education[i18n.language]}</p>
                                            <p className="team-title small">{data.experience[i18n.language]} {t('experince')}</p>
                                            <Link to={{pathname: `/doctor-details/${(data.name.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                                                            doctor: data
                                                                        }
                                                                    }}>
                                                <p className='text-warn font-weight-light small my-1'>{t("viewprofle")} <img src={arrow} style={{ height: 10 }} /></p>
                                            </Link>
                                            <BookingModal type="doctor" servicename={data.name[i18n.language]} service={data._id}/>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Team
